// Shared table furniture for the report views: the column-heading component
// and the cell classes its rows use.
//
// `scope` is set inside `Th` rather than at each call site so a new column
// cannot be added without it: these tables are read cell by cell, and an
// unassociated heading leaves the figures unlabelled.
//
// Numeric columns are right-aligned and tabular so a column of money or days
// lines up on its digits.

import type { ReactNode } from "react";

export const TH_CLASS =
  "px-3 py-2 text-left text-overline uppercase text-slate-600 dark:text-slate-400";
export const TH_NUMERIC_CLASS =
  "px-3 py-2 text-right text-overline uppercase text-slate-600 dark:text-slate-400";

export const TD_CLASS =
  "px-3 py-2 text-body-sm text-slate-900 dark:text-slate-100";
export const TD_NUMERIC_CLASS =
  "px-3 py-2 text-right text-body-sm tabular-nums text-slate-900 dark:text-slate-100";

export interface ThProps {
  children: ReactNode;
  numeric?: boolean;
}

/** A column heading, always scoped to its column. */
export function Th({ children, numeric = false }: ThProps) {
  return (
    <th scope="col" className={numeric ? TH_NUMERIC_CLASS : TH_CLASS}>
      {children}
    </th>
  );
}
